/** Default shape for optional social + IMDb URLs on store listings. */
export const emptySocialMediaLinks = () => ({
  facebook: "",
  instagram: "",
  twitter: "",
  youtube: "",
  linkedin: "",
  imdb: "",
});

export function normalizeSocialUrl(raw) {
  const s = String(raw ?? "").trim();
  if (!s) return "";
  if (/^https?:\/\//i.test(s)) return s;
  return `https://${s}`;
}

/** Parse API value (object or JSON string) into a plain object. */
export function parseSocialMediaLinks(value) {
  const base = emptySocialMediaLinks();
  if (value == null || value === "") return { ...base };
  let obj = value;
  if (typeof obj === "string") {
    try {
      obj = JSON.parse(obj || "{}");
    } catch {
      return { ...base };
    }
  }
  if (!obj || typeof obj !== "object") return { ...base };
  const out = { ...base };
  for (const k of Object.keys(base)) {
    if (typeof obj[k] === "string") out[k] = obj[k].trim();
  }
  return out;
}

/** [{ key, label, iconClass, url }] for links with non-empty normalized URL. */
export function getFilledSocialLinks(links) {
  const parsed = parseSocialMediaLinks(links);
  const defs = [
    { key: "facebook", label: "Facebook", iconClass: "fa-brands fa-facebook" },
    { key: "instagram", label: "Instagram", iconClass: "fa-brands fa-instagram" },
    { key: "twitter", label: "X (Twitter)", iconClass: "fa-brands fa-twitter" },
    { key: "youtube", label: "YouTube", iconClass: "fa-brands fa-youtube" },
    { key: "linkedin", label: "LinkedIn", iconClass: "fa-brands fa-linkedin-in" },
    { key: "imdb", label: "IMDb", iconClass: "fa-brands fa-imdb" },
  ];
  return defs
    .map((d) => {
      const raw = parsed[d.key];
      const url = normalizeSocialUrl(raw);
      if (!url) return null;
      return { ...d, url };
    })
    .filter(Boolean);
}

export function hasAnySocialLink(links) {
  return getFilledSocialLinks(links).length > 0;
}
